import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
export const formatDMY = (date) => {
    if (date !== null && date !== undefined)
        return dayjs(date).format("DD/MM/YYYY");
    return "";
};
export const formatRDWDate = (inputDate) => {
    try {
        let date;
        // Check if the input is in the format "YYYYMMDD" (e.g., "20230127")
        if (/^\d{8}$/.test(inputDate)) {
            let year = inputDate.substring(0, 4);
            let month = inputDate.substring(4, 6) - 1; // Months are 0-based in JavaScript
            let day = inputDate.substring(6, 8);
            date = new Date(year, month, day);
        }
        // Check if the input is in the format "YYYY-MM-DDTHH:mm:ss.sss" (e.g., "2024-02-14T00:00:00.000")
        else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}$/.test(inputDate)) {
            date = new Date(inputDate); // This is a valid ISO string
        }
        else {
            throw new Error('Invalid date format');
        }
        let formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
        return formattedDate;
    }
    catch (error) {
        return 'Invalid date';
    }
};
